var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideRightIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 47,
    viewBox: "0 0 16 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C4.69442 5.5 8.5 9.30558 8.5 14V28C8.5 32.6944 4.69442 36.5 0 36.5H-0.5V5.5H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "side_flap",
    d: "M0 5.5C4.69442 5.5 8.5 9.30558 8.5 14V28C8.5 32.6944 4.69442 36.5 0 36.5",
    fill: "none",
    stroke: "#C7F1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74894 20.4117C6.08369 20.7371 6.08369 21.2655 5.74894 21.5909L1.46418 25.756C1.12944 26.0813 0.585807 26.0813 0.25106 25.756C-0.0836868 25.4306 -0.0836868 24.9021 0.25106 24.5767L3.9306 21L0.253737 17.4233C-0.0810094 17.0979 -0.0810094 16.5694 0.253737 16.244C0.588484 15.9187 1.13211 15.9187 1.46686 16.244L5.75162 20.4091L5.74894 20.4117Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideRightIco);
export default __webpack_public_path__ + "static/media/Side_right_ico.4a9d921c5224498cec6c9aa080d45fab.svg";
export { ForwardRef as ReactComponent };